export const redefinePublicPath = () => {
  // We don't support setting public path in webpack via NPM build.
};